export enum SortingDirection {
    NONE = 'none',
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}
